<template>
  <div class="film">
    <div class="images">
      <loop-play-images
        v-if="bannerImagesData"
        :images-data="bannerImagesData"
        :background-appe-mode="false"
        :default-classes="defaultClasses"
      />
    </div>
    <div class="popular" style="z-index: -1"></div>
    <category-search-com
      :category-search-data="menuList"
      @categorySearchItemClick="categorySearchItemClick"
    />
    <div class="main" v-if="list.length > 0">
      <div class="title">热门推荐</div>
      <ul class="list">
        <li v-for="(item, index) in list" :key="index" @click="movieClick(item)">
          <img :src="item.image" />
          <div class="details">
            <div class="text">
              <span>{{ item.title }}</span>
              <span>{{ item.protagonist }}</span>
              <span>{{ item.brief }}</span>
            </div>
            <div class="num">{{ item.grade }}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="empty" v-else style="text-align: center">
      <img src="/img/no_data.043dd92a.png" alt="" />
    </div>
    <div class="pagination" v-if="total > pageSize">
      <el-pagination
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next, jumper"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus'
import { getToken } from '@/utils/auth'
import LoopPlayImages from '@/components/common/LoopPlayImages.vue'
import CategorySearchCom from '@/components/common/CategorySearchCom.vue'

export default {
  name: 'SearchPage',
  components: { LoopPlayImages, CategorySearchCom },
  data() {
    return {
      searchText: '',
      list: [],
      currentPage: 1,
      pageSize: 14,
      total: 0,
      menuList: [],
      bannerImagesData: null,
      defaultClasses: {
        outerRotateStage: 'loopImages',
        rotateStage: 'loopStage',
        innerShow: 'loopContainer',
        btn: 'btnOuter',
        circular: 'dots'
      },
      query: {
        pageSize: 14,
        totalElements: 0,
        pageNum: 0,
        orderByField: 'updatedTime',
        orderByType: 'DESC'
      }
    }
  },
  mounted() {
    this.searchText = this.$route.query.searchText || ''
    if (this.searchText) {
      this.query.videoName = this.searchText
    }
    if (this.$route.query.searchField) {
      try {
        Object.assign(this.query, JSON.parse(this.$route.query.searchField))
      } catch (e) {}
    }
    EventBus.$on('searchEvent', text => {
      this.query.videoName = text
      this.searchText = text
      this.getImageListData()
    })
    this.getBannerData()
    this.getImageListData()
    this.getSearchData()
  },
  beforeDestroy() {
    EventBus.$off('searchEvent')
  },
  methods: {
    getBannerData() {
      this.$axios({
        url: '/realNet/pageManager/findOne',
        method: 'get',
        headers: { token: '123456789' },
        params: { title: '搜索' }
      }).then(res => {
        if (res.data.result && res.data.result.dataMap) {
          const dataMap = res.data.result.dataMap
          if (dataMap.bannerList) {
            this.bannerImagesData = dataMap.bannerList.map(t => ({
              backgroundImage: t.image,
              imageLinkRouterName: t.link
            }))
          }
        }
      })
    },
    getSearchData() {
      this.$axios({
        url: '/realNet/pageManager/findOne',
        method: 'get',
        headers: { token: '123456789' },
        params: { title: '搜索' }
      }).then(res => {
        if (res.data.result && res.data.result.dataMap && res.data.result.dataMap.menuList) {
          const menuList = res.data.result.dataMap.menuList
          const searchField = this.$route.query.searchField
          menuList.forEach(menu => {
            let hasActive = false
            if (searchField && menu.menuList) {
              menu.menuList.some(item => {
                if (item.searchField && searchField.indexOf(item.searchField.substr(1, item.searchField.length - 2)) > -1) {
                  item.isActive = true
                  hasActive = true
                  return true
                }
                return false
              })
            }
            menu.menuList = [{ name: '全部', searchField: '{}', isActive: !hasActive }].concat(menu.menuList || [])
          })
          this.menuList = menuList
        }
      })
    },
    getImageListData() {
      this.$axios({
        url: '/realNet/video/getVideoInfos',
        method: 'get',
        headers: { token: getToken() || '123456789' },
        params: this.query
      }).then(res => {
        if (res.data.result) {
          const content = res.data.result.content || []
          this.list = content
            .map((item, idx) => ({
              id: item.id,
              image: idx === 0 ? (item.horizontalImage || item.verticalImage) : (item.verticalImage || item.horizontalImage),
              title: item.videoName,
              brief: item.description || '',
              grade: item.score ? item.score.toFixed(1) : '6.0',
              protagonist: item.protagonist || '',
              isRmhdDownload: item.isRmhdDownload
            }))
            .filter(item => item.image)
          this.total = res.data.result.totalElements || 0
          this.query.totalElements = this.total
        }
      })
    },
    categorySearchItemClick(filterParams, keywordParams, isClear) {
      if (isClear) {
        this.query = {
          pageSize: 14,
          totalElements: 0,
          pageNum: 0,
          orderByField: this.query.orderByField,
          orderByType: this.query.orderByType,
          videoName: this.searchText
        }
      } else {
        this.query = Object.assign({
          pageSize: 14,
          totalElements: 0,
          pageNum: 0,
          orderByField: this.query.orderByField,
          orderByType: this.query.orderByType,
          videoName: this.searchText
        }, filterParams, keywordParams)
      }
      this.currentPage = 1
      this.getImageListData()
    },
    movieClick(item) {
      if (item.isRmhdDownload) {
        this.$router.push({ path: '/download-detail', query: { id: item.id } })
      } else {
        this.$router.push({ path: '/tvplay-page', query: { id: item.id } })
      }
    },
    handlePageChange(page) {
      this.currentPage = page
      this.query.pageNum = page - 1
      this.getImageListData()
      try {
        document.documentElement.scrollTop = 750
      } catch (e) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.film {
  overflow: hidden;
}

.images {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;

  ::v-deep img {
    z-index: 1;
    position: relative;
    height: 640px !important;
    width: 100%;
  }

  ::v-deep #loopImages {
    height: 640px !important;
  }
}

.popular {
  position: absolute;
  top: 640px;
  width: 100%;
  height: 446px;
  background: linear-gradient(180deg, rgba(50, 40, 210, 0.3), rgba(209, 47, 60, 0));
  z-index: 1;
}

::v-deep .label {
  width: 1196px;
  margin: 614px auto 49px;
  background: transparent;
  padding: 0;
  border-radius: 0;

  .lable_column {
    font-family: PingFang;
    font-weight: 700;
    font-size: 14px;
    color: #000;
    display: flex;
    align-items: flex-start;
    margin-bottom: 0;

    .title {
      width: 64px;
      flex-shrink: 0;
    }

    ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      cursor: pointer;
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-right: 22px;
        margin-bottom: 20px;
        font-weight: 400;

        &.select {
          color: #772b92;
        }
      }
    }
  }
}

.main {
  width: 1196px;
  margin: auto;

  .title {
    font-family: PingFang;
    font-weight: 700;
    font-size: 30px;
    color: #000;
    margin-bottom: 22px;
    padding: 0;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      width: 223px;
      flex-direction: column;
      margin-bottom: 30px;
      margin-right: 20px;
      cursor: pointer;
      overflow: hidden;

      &:nth-child(4),
      &:nth-child(9),
      &:nth-child(14) {
        margin-right: 0;
      }

      img {
        width: 100%;
        height: 314px;
        margin-bottom: 10px;
        object-fit: cover;
        border-radius: 4px;
      }

      .details {
        display: flex;
        padding: 0 8px 0 6px;
        box-sizing: border-box;
        justify-content: space-between;
      }

      .text {
        width: 185px;

        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          font-family: PingFang;
          font-weight: 400;
          display: inline-block;

          &:first-child {
            font-size: 16px;
            color: #000;
          }

          &:nth-child(2) {
            font-size: 14px;
            color: #999;
          }

          &:nth-child(3) {
            font-size: 14px;
            color: #333;
          }
        }
      }

      .num {
        font-family: PingFang;
        font-weight: 700;
        font-size: 16px;
        color: red;
        font-style: italic;
      }

      &:first-child {
        width: 467px;
        height: 400px;
        background: #fff;
        box-shadow: 0 0 8px 1px rgba(4, 0, 0, 0.13);
        border-radius: 5px;
        margin-right: 20px;

        img {
          margin-bottom: 7px;
          height: auto;
        }

        .details {
          padding-right: 19px;
        }

        .text {
          width: 400px;

          span:first-child {
            font-size: 20px;
          }
        }

        .num {
          font-size: 24px;
        }
      }
    }
  }
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 27px;
  margin-bottom: 21px;
}

.empty {
  text-align: center;
  padding: 100px 0;

  img {
    width: 200px;
  }
}
</style>
